<script setup>
import GlTabs from "~/components/gitlab/GlTabs.vue";
import GlSearchBoxByClick from "~/components/gitlab/GlSearchBoxByClick.vue";
import GlSorting from "~/components/gitlab/GlSorting.vue";

defineProps({
  activeTabIndex: { default: 0, type: Number },
  isAdmin: { default: false, type: Boolean },
  isAscending: { default: false, type: Boolean },
  sortBy: { default: null, type: [String, Number] },
  sortOptions: { required: true, type: Array },
  tabs: { required: true, type: Array }
});

const searchQuery = defineModel("searchQuery", { default: "", type: String });

const emit = defineEmits(["tab-change", "search", "new-project", "sort-by-change", "sort-direction-change"]);
</script>

<template>
  <div class="mb-0">
    <!-- Page title row -->
    <div class="mb-4 flex items-center justify-between">
      <h1 class="text-2xl font-semibold text-[var(--gl-text-color-heading)]">Projects</h1>
      <button
        v-if="isAdmin"
        id="new-project"
        type="button"
        class="rounded-[var(--gl-action-border-radius)] bg-[var(--gl-button-confirm-primary-background-color-default)] px-4 py-2 text-sm font-medium text-[var(--gl-button-confirm-primary-foreground-color-default)] hover:bg-[var(--gl-button-confirm-primary-background-color-hover)] hover:text-[var(--gl-button-confirm-primary-foreground-color-hover)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--gl-focus-ring-outer-color)]"
        @click="emit('new-project')"
      >
        New project
      </button>
    </div>

    <!-- Tab bar -->
    <div>
      <GlTabs :tabs="tabs" :model-value="activeTabIndex" @update:model-value="emit('tab-change', $event)" />
    </div>

    <!-- Search bar + sort controls row -->
    <div class="flex items-center gap-3 bg-[var(--gl-background-color-subtle)] px-3 py-3">
      <div class="min-w-0 flex-1">
        <GlSearchBoxByClick v-model="searchQuery" placeholder="Filter by name" @search="emit('search')" />
      </div>
      <GlSorting
        :sort-options="sortOptions"
        :sort-by="sortBy"
        :is-ascending="isAscending"
        @sort-by-change="emit('sort-by-change', $event)"
        @sort-direction-change="emit('sort-direction-change', $event)"
      />
    </div>
  </div>
</template>
